import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { ISelectFormatSection } from "./types";
import { ListElement } from "./ListElement";

type IProps = ISelectFormatSection & JSX.IntrinsicElements["div"];

export const SelectFormatSection: React.FC<IProps> = ({
  title,
  children,
  ...rest
}) => {
  const { t } = useTranslation();
  const { css } = useFela();
  const { bp } = useTheme();

  return (
    <Grid
      id="SelectFormatSection"
      customStyle={{
        position: "relative",
        flexDirection: "column",
      }}
      {...rest}
    >
      <Heading as="h2" customStyle={{ textAlign: "center" }}>
        {title}
      </Heading>
      <div
        className={css({
          display: "flex",
          flexDirection: "column-reverse",
          alignItems: "center",
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
            justifyContent: "space-between",
          },
        })}
      >
        <div
          className={css({
            width: "100%",
            flex: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            [bp.FROM_DESKTOP]: {
              alignItems: "flex-start",
              padding: "0 70px 0 50px",
            },
          })}
        >
          <ul
            className={css({
              width: "100%",
              margin: 0,
              listStyleType: "none",
            })}
          >
            <ListElement
              iconTypeFrom="ADOBEXD"
              iconTypeTo="FIGMA"
              text={t("section/selectFormat:xdToFigma")}
              href="/converter/xd-to-figma"
            />
            <ListElement
              iconTypeFrom="FIGMA"
              iconTypeTo="ADOBEXD"
              text={t("section/selectFormat:figmaToXd")}
              href="/converter/figma-to-xd"
            />
            <ListElement
              iconTypeFrom="FIGMA"
              iconTypeTo="SKETCH"
              text={t("section/selectFormat:figmaToSketch")}
              href="/converter/figma-to-sketch"
            />
            <ListElement
              iconTypeFrom="AI"
              iconTypeTo="FIGMA"
              text={t("section/selectFormat:illustratorToFigma")}
              href="/converter/ai-to-figma"
            />
          </ul>
        </div>

        <div
          className={css({
            flex: 1,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            [bp.FROM_DESKTOP]: {
              marginBottom: 45,
            },
          })}
        >
          <div
            className={css({
              width: "100%",
              marginBottom: 20,
              transform: "translateX(-7.5%)",
              [bp.FROM_DESKTOP]: {
                maxWidth: 430,
                marginBottom: 0,
                marginRight: "auto",
                transform: "translateY(0)",
              },
              [bp.FROM_LARGE_DESKTOP]: { maxWidth: 460 },
            })}
          >
            <img
              src="/svgs/magician-with-bubbles.svg"
              alt="magician with bubbles"
            />
          </div>
        </div>
      </div>
    </Grid>
  );
};
